module.exports = function() {
  return new Worker(__webpack_public_path__ + "9c619209dfff75962f67.worker.js");
};